import { defineRecipe } from '@chakra-ui/react';

export const separatorRecipe = defineRecipe({
    base: {
        borderColor: 'gray.200',
    },
});
